import {
  faPeanuts,
  faPig,
  faGlass,
  faLobster,
  faEgg,
  faFish,
  faWheat,
  type IconDefinition
} from "@fortawesome/pro-light-svg-icons";

import { type AllergenName } from "~/api/products/types";
import { type Language } from "~/api/tills/types";

export const ALLERGENS_LIST = [
  {
    key: "wheat",
    names: {
      da: "Gluten",
      no: "Gluten",
      en: "Gluten",
      nl: "Gluten",
      sv: "Gluten",
      el: "Γλουτένη",
      pl: "Gluten",
      it: "Glutine",
      pt: "Glúten",
      uk: "Глютен",
      ro: "Gluten",
      fr: "Gluten",
      de: "Gluten",
      es: "Gluten",
      hu: "Glutén",
      bg: "Глутен",
      zh: "谷蛋白",
      tr: "Gluten",
      ga: "Glútan"
    },
    faIcon: faWheat
  },
  {
    key: "wheat:wheat",
    names: {
      da: "Hvede",
      en: "Wheat",
      no: "Hvete",
      nl: "Tarwe",
      sv: "Vete",
      el: "Σιτάρι",
      pl: "Pszenica",
      it: "Frumento",
      pt: "Trigo",
      uk: "Пшениця",
      ro: "Grâu",
      fr: "Blé",
      de: "Weizen",
      es: "Trigo",
      hu: "Búza",
      bg: "Пшеница",
      zh: "小麦",
      tr: "Buğday",
      ga: "Cruithneacht"
    }
  },
  {
    key: "wheat:rye",
    names: {
      da: "Rug",
      en: "Rye",
      no: "Rug",
      nl: "Rogge",
      sv: "Råg",
      el: "Σίκαλη",
      pl: "Żyto",
      it: "Segale",
      pt: "Centeio",
      uk: "Жито",
      ro: "Secară",
      fr: "Seigle",
      de: "Roggen",
      es: "Centeno",
      hu: "Rozs",
      bg: "Ръж",
      zh: "黑麦",
      tr: "Çavdar",
      ga: "Seagal"
    }
  },
  {
    key: "wheat:barley",
    names: {
      da: "Byg",
      en: "Barley",
      no: "Bygg",
      nl: "Gerst",
      sv: "Korn",
      el: "Κριθάρι",
      pl: "Jęczmień",
      it: "Orzo",
      pt: "Cevada",
      uk: "Ячмінь",
      ro: "Orz",
      fr: "Orge",
      de: "Gerste",
      es: "Cebada",
      hu: "Árpa",
      bg: "Ечемик",
      zh: "大麦",
      tr: "Arpa",
      ga: "Eorna"
    }
  },
  {
    key: "wheat:oats",
    names: {
      da: "Havre",
      en: "Oats",
      no: "Havre",
      nl: "Haver",
      sv: "Havre",
      el: "Βρώμη",
      pl: "Owies",
      it: "Avena",
      pt: "Aveia",
      uk: "Овес",
      ro: "Ovăz",
      fr: "Avoine",
      de: "Hafer",
      es: "Avena",
      hu: "Zab",
      bg: "Овес",
      zh: "燕麦",
      tr: "Yulaf",
      ga: "Coirce"
    }
  },
  {
    key: "wheat:spelt",
    names: {
      da: "Spelt",
      en: "Spelt",
      no: "Spelt",
      nl: "Spelt",
      sv: "Dinkel",
      el: "Ντίνκελ",
      pl: "Orkisz",
      it: "Farro",
      pt: "Espelta",
      uk: "Спельта",
      ro: "Alac",
      fr: "Épeautre",
      de: "Dinkel",
      es: "Espelta",
      hu: "Tönkölybúza",
      bg: "Лимец",
      zh: "斯佩尔特小麦",
      tr: "Kavılca buğdayı",
      ga: "Spealtas"
    }
  },
  {
    key: "wheat:kamut",
    names: {
      da: "Kamut",
      en: "Kamut",
      no: "Kamut",
      nl: "Kamut",
      sv: "Kamut",
      el: "Καμούτ",
      pl: "Kamut",
      it: "Kamut",
      pt: "Kamut",
      uk: "Камут",
      ro: "Kamut",
      fr: "Kamut",
      de: "Kamut",
      es: "Kamut",
      hu: "Kamut",
      bg: "Камут",
      zh: "卡姆小麦",
      tr: "Kamut buğdayı",
      ga: "Kamut"
    }
  },
  {
    key: "celery",
    names: {
      da: "Selleri",
      en: "Celery",
      no: "Selleri",
      nl: "Selderij",
      sv: "Selleri",
      el: "Σέλινο",
      pl: "Seler",
      it: "Sedano",
      pt: "Aipo",
      uk: "Селера",
      ro: "Țelină",
      fr: "Céleri",
      de: "Sellerie",
      es: "Apio",
      hu: "Zeller",
      bg: "Целина",
      zh: "芹菜",
      tr: "Kereviz",
      ga: "Soilire"
    }
  },
  {
    key: "crustaceans",
    names: {
      da: "Krebsdyr",
      en: "Crustaceans",
      no: "Krepsdyr",
      nl: "Schaaldieren",
      sv: "Skaldjur",
      el: "Καρκινοειδή",
      pl: "Skorupiaki",
      it: "Crostacei",
      pt: "Crustáceos",
      uk: "Ракоподібні",
      ro: "Crustacee",
      fr: "Crustacés",
      de: "Krustentiere",
      es: "Crustáceos",
      hu: "Rákfélék",
      bg: "Ракообразни",
      zh: "甲壳动物",
      tr: "Kabuklular",
      ga: "Crústaigh"
    },
    faIcon: faLobster
  },
  {
    key: "egg",
    names: {
      da: "Æg",
      en: "Egg",
      no: "Egg",
      nl: "Ei",
      sv: "Ägg",
      el: "Αυγά",
      pl: "Jajka",
      it: "Uovo",
      pt: "Ovos",
      uk: "Яйця",
      ro: "Ouă",
      fr: "Œuf",
      de: "Ei",
      es: "Huevo",
      hu: "Tojás",
      bg: "Яйца",
      zh: "鸡蛋",
      tr: "Yumurta",
      ga: "Ubh"
    },
    faIcon: faEgg
  },
  {
    key: "fish",
    names: {
      da: "Fisk",
      en: "Fish",
      no: "Fisk",
      nl: "Vis",
      sv: "Fisk",
      el: "Ψάρι",
      pl: "Ryba",
      it: "Pesce",
      pt: "Peixe",
      uk: "Риба",
      ro: "Pește",
      fr: "Poisson",
      de: "Fisch",
      es: "Pescado",
      hu: "Hal",
      bg: "Риба",
      zh: "鱼",
      tr: "Balık",
      ga: "Iasc"
    },
    faIcon: faFish
  },
  {
    key: "lupin",
    names: {
      da: "Lupin",
      en: "Lupine",
      no: "Lupin",
      nl: "Lupine",
      sv: "Lupin",
      el: "Λουπίνο",
      pl: "Łubin",
      it: "Lupino",
      pt: "Lupino",
      uk: "Люпин",
      ro: "Lupin",
      fr: "Lupin",
      de: "Lupine",
      es: "Lupino",
      hu: "Lupin",
      bg: "Люпин",
      zh: "羽扇豆",
      tr: "Lupin",
      ga: "Lúipín"
    }
  },
  {
    key: "milk",
    names: {
      da: "Mælk",
      en: "Milk",
      no: "Melk",
      nl: "Melk",
      sv: "Mjölk",
      el: "Γάλα",
      pl: "Mleko",
      it: "Latte",
      pt: "Leite",
      uk: "Молоко",
      ro: "Lapte",
      fr: "Lait",
      de: "Milch",
      es: "Leche",
      hu: "Tej",
      bg: "Мляко",
      zh: "牛奶",
      tr: "Süt",
      ga: "Bainne"
    },
    faIcon: faGlass
  },
  {
    key: "molluscs",
    names: {
      da: "Bløddyr",
      en: "Molluscs",
      no: "Bløtdyr",
      nl: "Weekdieren",
      sv: "Blötdjur",
      el: "Μαλάκια",
      pl: "Mięczaki",
      it: "Molluschi",
      pt: "Moluscos",
      uk: "Молюски",
      ro: "Moluște",
      fr: "Mollusques",
      de: "Weichtiere",
      es: "Moluscos",
      hu: "Puhatestűek",
      bg: "Мекотели",
      zh: "软体动物",
      tr: "Yumuşakçalar",
      ga: "Moilisc"
    }
  },
  {
    key: "mustard",
    names: {
      da: "Sennep",
      en: "Mustard",
      no: "Sennep",
      nl: "Mosterd",
      sv: "Senap",
      el: "Μουστάρδα",
      pl: "Musztarda",
      it: "Senape",
      pt: "Mostarda",
      uk: "Гірчиця",
      ro: "Muștar",
      fr: "Moutarde",
      de: "Senf",
      es: "Mostaza",
      hu: "Mustár",
      bg: "Синап",
      zh: "芥末",
      tr: "Hardal",
      ga: "Mustaird"
    }
  },
  {
    key: "nuts",
    names: {
      da: "Nødder",
      en: "Nuts",
      no: "Nøtter",
      nl: "Noten",
      sv: "Nötter",
      el: "Ξηροί καρποί",
      pl: "Orzechy",
      it: "Noci",
      pt: "Nozes",
      uk: "Горіхи",
      ro: "Nuci",
      fr: "Noix",
      de: "Nüsse",
      es: "Nueces",
      hu: "Diófélék",
      bg: "Ядки",
      zh: "坚果",
      tr: "Fındık",
      ga: "Cnónna"
    },
    faIcon: faPeanuts
  },
  {
    key: "nuts:almonds",
    names: {
      da: "Mandler",
      en: "Almonds",
      no: "Mandler",
      nl: "Amandelen",
      sv: "Mandlar",
      el: "Αμύγδαλα",
      pl: "Migdały",
      it: "Mandorle",
      pt: "Amêndoas",
      uk: "Мигдаль",
      ro: "Migdale",
      fr: "Amandes",
      de: "Mandeln",
      es: "Almendras",
      hu: "Mandula",
      bg: "Бадеми",
      zh: "杏仁",
      tr: "Badem",
      ga: "Almóinní"
    }
  },
  {
    key: "nuts:hazelnuts",
    names: {
      da: "Hasselnødder",
      en: "Hazelnuts",
      no: "Hasselnøtter",
      nl: "Hazelnoten",
      sv: "Hasselnötter",
      el: "Φουντούκια",
      pl: "Orzechy laskowe",
      it: "Nocciole",
      pt: "Avelãs",
      uk: "Ліщина",
      ro: "Alune de pădure",
      fr: "Noisettes",
      de: "Haselnüsse",
      es: "Avellanas",
      hu: "Mogyoró",
      bg: "Лешници",
      zh: "榛子",
      tr: "Fındık",
      ga: "Cnónna coill"
    }
  },
  {
    key: "nuts:walnuts",
    names: {
      da: "Valnødder",
      en: "Walnuts",
      no: "Valnøtter",
      nl: "Walnoten",
      sv: "Valnötter",
      el: "Καρύδια",
      pl: "Orzechy włoskie",
      it: "Noci",
      pt: "Nozes",
      uk: "Волоські горіхи",
      ro: "Nuci",
      fr: "Noix",
      de: "Walnüsse",
      es: "Nueces",
      hu: "Dió",
      bg: "Орехи",
      zh: "核桃",
      tr: "Ceviz",
      ga: "Gallchnónna"
    }
  },
  {
    key: "nuts:cashew",
    names: {
      da: "Cashewnødder",
      en: "Cashew nuts",
      no: "Cashewnøtter",
      nl: "Cashewnoten",
      sv: "Cashewnötter",
      el: "Κάσιους",
      pl: "Orzechy nerkowca",
      it: "Anacardi",
      pt: "Cajus",
      uk: "Кеш'ю",
      ro: "Caju",
      fr: "Noix de cajou",
      de: "Cashewnüsse",
      es: "Anacardos",
      hu: "Kajszibarackmag",
      bg: "Кашу",
      zh: "腰果",
      tr: "Kaju",
      ga: "Cnónna caisiú"
    }
  },
  {
    key: "nuts:pecan",
    names: {
      da: "Pekannødder",
      en: "Pecan nuts",
      no: "Pekannøtter",
      nl: "Pecannoten",
      sv: "Pekannötter",
      el: "Πεκάν",
      pl: "Orzechy pekan",
      it: "Noci di pecan",
      pt: "Nozes-pecã",
      uk: "Пекан",
      ro: "Nuci pecan",
      fr: "Noix de pécan",
      de: "Pekannüsse",
      es: "Nueces de pecán",
      hu: "Pekánnusz",
      bg: "Пекан",
      zh: "美洲山核桃",
      tr: "Pekan",
      ga: "Cnónna pecan"
    }
  },
  {
    key: "nuts:pistachio",
    names: {
      da: "Pistacienødder",
      en: "Pistachio nuts",
      no: "Pistasjnøtter",
      nl: "Pistachenoten",
      sv: "Pistagenötter",
      el: "Φιστίκια",
      pl: "Orzechy pistacjowe",
      it: "Pistacchi",
      pt: "Pistácios",
      uk: "Фісташки",
      ro: "Fistic",
      fr: "Pistaches",
      de: "Pistazien",
      es: "Pistachos",
      hu: "Pisztácia",
      bg: "Фистаци",
      zh: "开心果",
      tr: "Fıstık",
      ga: "Cnónna pistéise"
    }
  },
  {
    key: "nuts:brazil",
    names: {
      da: "Paranødder",
      en: "Brazil nuts",
      no: "Paranøtter",
      nl: "Paranoten",
      sv: "Paranötter",
      el: "Καρύδια του Βραζιλία",
      pl: "Orzechy brazylijskie",
      it: "Noci del Brasile",
      pt: "Nozes do Brasil",
      uk: "Бразильські горіхи",
      ro: "Nuci de Brazilia",
      fr: "Noix du Brésil",
      de: "Paranüsse",
      es: "Nueces de Brasil",
      hu: "Brazil dió",
      bg: "Бразилски орехи",
      zh: "巴西坚果",
      tr: "Brezilya fındığı",
      ga: "Cnónna Bhrasaíl"
    }
  },
  {
    key: "nuts:macadamia",
    names: {
      da: "Queenslandnødder",
      en: "Macadamia nuts",
      no: "Macadamianøtter",
      nl: "Macadamianoten",
      sv: "Macadamianötter",
      el: "Καρύδια Macadamia",
      pl: "Orzechy macadamia",
      it: "Noci di macadamia",
      pt: "Nozes de macadâmia",
      uk: "Макадамія",
      ro: "Nuci de macadamia",
      fr: "Noix de macadamia",
      de: "Macadamianüsse",
      es: "Nueces de macadamia",
      hu: "Macadamia dió",
      bg: "Макадамия",
      zh: "夏威夷果",
      tr: "Macadamia fındığı",
      ga: "Cnónna macadamia"
    }
  },
  {
    key: "peanut",
    names: {
      da: "Jordnødder",
      en: "Peanuts",
      no: "Peanøtter",
      nl: "Pinda's",
      sv: "Jordnötter",
      el: "Φιστίκια",
      pl: "Orzeszki ziemne",
      it: "Arachidi",
      pt: "Amendoins",
      uk: "Арахіс",
      ro: "Arahide",
      fr: "Arachides",
      de: "Erdnüsse",
      es: "Cacahuetes",
      hu: "Földimogyoró",
      bg: "Фъстъци",
      zh: "花生",
      tr: "Fıstık",
      ga: "Píseanna talún"
    }
  },
  {
    key: "pork",
    names: {
      da: "Gris",
      en: "Pork",
      no: "Svinekjøtt",
      nl: "Varkensvlees",
      sv: "Fläskkött",
      el: "Χοιρινό",
      pl: "Wieprzowina",
      it: "Maiale",
      pt: "Carne de porco",
      uk: "Свинина",
      ro: "Porc",
      fr: "Porc",
      de: "Schwein",
      es: "Cerdo",
      hu: "Sertés",
      bg: "Свинско",
      zh: "猪肉",
      tr: "Domuz eti",
      ga: "Muiceoil"
    },
    faIcon: faPig
  },
  {
    key: "sesame",
    names: {
      da: "Sesam",
      en: "Sesame",
      no: "Sesam",
      nl: "Sesam",
      sv: "Sesam",
      el: "Σουσάμι",
      pl: "Sezam",
      it: "Sesamo",
      pt: "Gergelim",
      uk: "Кунжут",
      ro: "Susam",
      fr: "Sésame",
      de: "Sesam",
      es: "Sésamo",
      hu: "Szezámmag",
      bg: "Сусам",
      zh: "芝麻",
      tr: "Susam",
      ga: "Sesame"
    }
  },
  {
    key: "soya",
    names: {
      da: "Soja",
      en: "Soy",
      no: "Soya",
      nl: "Soja",
      sv: "Soja",
      el: "Σόγια",
      pl: "Soja",
      it: "Soia",
      pt: "Soja",
      uk: "Соя",
      ro: "Soia",
      fr: "Soja",
      de: "Soja",
      es: "Soja",
      hu: "Szója",
      bg: "Соя",
      zh: "大豆",
      tr: "Soya",
      ga: "Soighe"
    }
  },
  {
    key: "sulphurdioxide",
    names: {
      da: "Svovldioxid og sulfitter",
      en: "Sulphur dioxide and sulphites",
      no: "Svoveldioksid og sulfitter",
      nl: "Zwaveldioxide en sulfieten",
      sv: "Svaveldioxid och sulfiter",
      el: "Διοξείδιο του θείου και θειώδη",
      pl: "Dwutlenek siarki i siarczyny",
      it: "Anidride solforosa e solfiti",
      pt: "Dióxido de enxofre e sulfitos",
      uk: "Діоксид сірки та сульфіти",
      ro: "Dioxid de sulf și sulfiți",
      fr: "Dioxyde de soufre et sulfites",
      de: "Schwefeldioxid und Sulfite",
      es: "Dióxido de azufre y sulfitos",
      hu: "Kén-dioxid és szulfitok",
      bg: "Сярна киселина и сулфити",
      zh: "二氧化硫和亚硫酸盐",
      tr: "Kükürt dioksit ve sülfürler",
      ga: "Díocsáid sulfair agus sulfáití"
    }
  }
] as const satisfies readonly {
  key: AllergenName;
  names: Record<Language, string>;
  faIcon?: IconDefinition;
}[];

export type AllergenLanguageCode =
  keyof (typeof ALLERGENS_LIST)[number]["names"];
